module.exports = __webpack_public_path__ + "hyperion-v2-static/img/grd-welcome-image.547b9e0d.png";